declare global {
    interface Navigator {
        standalone?: boolean;
    }
}

export const getIsElectronMac = () => process.env.APPLICATION_MODE === 'electron';
export const isIosPwa = () => !!global.navigator?.standalone;
export const isNonIosDevicePwa = () =>
    global.matchMedia &&
    (global.matchMedia('(display-mode: standalone)').matches ||
        global.matchMedia('(display-mode: window-controls-overlay)').matches);
export const isPwa = () => isIosPwa() || isNonIosDevicePwa();
export const isInIFrame = () => !!global.window && global.window.self !== global.window.top;
